import { Injectable } from '@angular/core';
import { linkAccountResp } from '@biz-models/network/account-model-network';
import { L7Response } from '@biz-models/network/l7-response.model';
import {
	LoginNetworkModel,
	LoginRespModel,
	socialLinkResp,
	subdomainLinkReq,
	subdomainLinkResp,
	subdomainUnlinkResp,
} from '@biz-models/network/login-authenticate-network.model';
import { Observable } from 'rxjs';
import { ApiService } from 'src/controls/api/shared/api.service';
import { AjaxService } from './ajax.service';

const _MICROSERVICE = 'sso-ms';
@Injectable({
	providedIn: 'root',
})
export class LoginService {
	test: any;

	constructor(private ajax: AjaxService, private apiService: ApiService) {}

	login(data: LoginNetworkModel) {
		return this.apiService.postWithoutToken$<L7Response<LoginRespModel[]>>(_MICROSERVICE, 'auth/login', data);
	}

	logOut(data) {
		return this.apiService.post$<L7Response<any>>(_MICROSERVICE, 'auth/logout', data);
	}

	getToken(signature: string): Observable<any> {
		return this.ajax.get('sso', 'token/' + signature);
	}

	socialLogin(data: any): Observable<any> {
		return this.ajax.post('sso', 'auth/login/social', data);
	}

	socialLink(data: { provider: string; token: string }) {
		return this.apiService.post$<L7Response<socialLinkResp>>(_MICROSERVICE, 'auth/link/social', data);
	}

	socialUnlink(id: number) {
		return this.apiService.delete$<L7Response<socialLinkResp>>(_MICROSERVICE, 'auth/unlink/social/' + id);
	}

	listLinkAccount() {
		return this.apiService.get$<L7Response<linkAccountResp[]>>(_MICROSERVICE, 'auth/identity/providers');
	}

	linkSubdoamin(data: subdomainLinkReq) {
		return this.apiService.post$<L7Response<subdomainLinkResp>>(_MICROSERVICE, 'auth/link/subdomain', data);
	}

	unlinkSubdomain(data: string) {
		return this.apiService.post$<L7Response<subdomainUnlinkResp>>(_MICROSERVICE, 'auth/unlink/subdomain', {
			unlink_subdomain: data,
		});
	}
}
